export const DATA_FRESHNESS_MS = {
  catalogList: 300_000,
  storeList: 300_000,
  productDetail: 600_000,
  seoDefaults: 3_600_000,
  searchAutocomplete: 45_000,
} as const

const REACT_QUERY_GC_MULTIPLIER = 3

export const toNextRevalidateSeconds = (ms: number): number =>
  Number.isFinite(ms) && ms > 0 ? Math.max(1, Math.floor(ms / 1000)) : 1

export const toReactQueryGcTime = (staleMs: number): number =>
  Math.max(0, Number.isFinite(staleMs) ? staleMs : 0) *
  REACT_QUERY_GC_MULTIPLIER
